
export default {
    configuration: true,
    'searchList': {
        'searchTxt': [
            {
                'name': '模板编码',
                'value': 'chooseCode',
                'type': 'input',
                'unfold': true,
                'span': 3
            },
            {
                'name': '模板名称',
                'value': 'chooseName',
                'type': 'input',
                'unfold': true,
                'span': 3
            },
            {
                'name': '平台',
                'value': 'siteName',
                'unfold': true,
                'advanceConfig': [
                    { 'prop': 'escoCompanyNameCn', 'value': '服务平台名称' },
                    { 'prop': 'escoCompanyNo', 'value': '服务平台编码' }
                ],
                'tableConfig': [
                    { 'prop': 'escoCompanyNo', 'value': '服务平台编码' },
                    { 'prop': 'escoCompanyNameCn', 'value': '服务平台名称' }
                ],
                'advanceUrl': '/searchPlatform',
                'type': 'advance',
                'cbParams': ['escoCompanyNo#siteCode', 'escoCompanyNameCn#siteName'],
                'span': 4
            },
            {
                'name': '是否启用',
                'value': 'isUse',
                'type': 'select',
                'options': [
                    { label: '是', value: '0' },
                    { label: '否', value: '1' }
                ],
                'unfold': true,
                'span': 3
            }
        ],
        'unfoldState': false,
        'advancedBtn': false
    },
    'table': {
        'clickModify': true,
        'selectBtn': true,
        'leftWidth': 160,
        'height': '400px',
        leftOperation: true,
        'columns': [
            {
                'label': '服务平台',
                'prop': 'siteName',
                'width': 200,
                'sort': true
            },
            {
                'label': '模板编码',
                'prop': 'chooseCode',
                'type': 'button',
                'width': 140,
                'sort': true
            },
            {
                'label': '模板名称',
                'prop': 'chooseName',
                'width': 120,
                'sort': true
            },
            {
                'label': '模板描述',
                'prop': 'remark',
                'width': 260,
                'sort': true
            },
            {
                'label': '是否启用',
                'prop': 'isUseName',
                'width': 100,
                'sort': true
            },
            {
                'label': '修改人',
                'prop': 'updateUserName',
                'width': 100,
                'sort': true
            },
            {
                'label': '修改时间',
                'prop': 'updateTime',
                'width': 140,
                'sort': true
            }
        ],
        'action': [
            {
                'type': 'text',
                'label': '编辑',
                'size': 'small',
                'event': 'edit',
                'ifHas': 'otp02050002'
            },
            {
                'type': 'text',
                'label': '删除',
                'size': 'small',
                'event': 'del',
                'ifHas': 'otp02050003'
            },
            {
                'type': 'text',
                'label': '启用',
                'size': 'small',
                'event': 'enable',
                'ifHas': 'otp02050004'
            },
            {
                'type': 'text',
                'label': '停用',
                'size': 'small',
                'event': 'disable',
                'ifHas': 'otp02050005'
            }
        ]
    },
    'page': {
        'layout': 'total, sizes, prev, pager, next',
        'pageSize': 10,
        'pageSizes': [
            10,
            20,
            30,
            50
        ]
    }
};
